{
    "dashboard": {
        "addDashboard": "Ajouter un tableau de bord",
        "alreadyExists": "Un tableau de bord nommé {dashboardName} existe déjà.",
        "confirmDeleteMessage": "Êtes-vous sûr de vouloir supprimer",
        "detailsUrlExpression": "Expression URL détails",
        "detailsUrlExpressionInfo": "Expression pour extraire l'URL utilisée au clic sur ",
        "detailsUrlExpressionInfo1": " dans certains widgets",
        "schemaDefinitionExpression": "Expression de définition de schéma",
        "enableSelection": "Activer la sélection",
        "copyDashboard": "Copier le tableau de bord",
        "copyDashboardSuccess": "Tableau de bord copié avec succès",
        "dashboard": "Tableau de bord",
        "dashboardDesc": "Description du tableau de bord",
        "searchDashboards": "Rechercher des tableaux de bord",
        "dashboardId": {
            "noWidgetsInDashboard": "Il n’y a aucun widget dans ce tableau de bord",
            "noWidgets": "Il n’y a aucun widget dans ",
            "noWidgetsAdded": "Aucun widget n’a encore été ajouté.\nCliquez sur un widget ci-dessus et \nfaites-le glisser pour en créer un nouveau.",
            "updateRoleSuccess": "Rôle mis à jour avec succès",
            "widget": {
                "addCondition": "Ajouter une condition",
                "barChart": "Histogramme",
                "chartType": "Type de graphique",
                "column": "Colonne",
                "copyToDashboard": "Copier vers un tableau de bord",
                "copyWidget": "Copier le widget",
                "copyWidgetSuccess": "Widget copié avec succès",
                "count": "Nombre",
                "dataset": "Choisir un jeu de données pour le widget",
                "deleteCondition": "Supprimer la condition",
                "deleteWidgetSuccess": "Widget supprimé avec succès",
                "display": "Afficher",
                "editWidget": "Modifier le widget",
                "exportScheduled": "Eksport planlagt. Du vil få en varsling når den er klar",
                "field": "Champ",
                "goAheadAndSearchForRecordsIn": "Lancez une recherche dans",
                "infoBox": "Boîte d’information",
                "itemColor": "Couleur de l’élément",
                "items": "Éléments",
                "label": "Libellé",
                "lineChart": "Courbe",
                "newWidget": "Nouveau widget",
                "noRecordsToDisplay": "Aucun enregistrement à afficher.",
                "noDataAvailable": "Aucune donnée disponible",
                "notLinked": "Non lié",
                "notPossibleToDownload": "For mye data til å laste ned",
                "noWidgets": "Aucun widget ",
                "number": "Nombre",
                "optionalDescription": "Description optionnelle du widget",
                "optionalDescriptionWidget": "Description optionnelle du widget",
                "show": "Afficher",
                "table": "Tableau",
                "tabMenu": {
                    "addField": "Ajouter un nom de champ",
                    "activeWidget": "widget actif",
                    "addRule": "Ajouter une règle",
                    "addViewDetailsButton": "Ajouter un bouton Voir les détails",
                    "advancedFilter": "Filtre avancé",
                    "advancedCondition": "Condition avancée",
                    "advancedFilterInfoTooltip": "Informations détaillées sur l’écriture d’une requête",
                    "appName": "Nom de l’application",
                    "appUrl": "URL de l’application",
                    "advancedFilterQueryGuide": {
                        "and": "Et",
                        "andDescription": "L’opérateur AND affiche un enregistrement si toutes les conditions séparées par AND sont vraies.",
                        "andExample": "ItemType:Ext AND Status:[10 TO 20]",
                        "between": "Entre",
                        "betweenDescription": "En SQL, BETWEEN filtre les valeurs dans un intervalle. Ici, on utilise les crochets [ ] pour les intervalles inclusifs.",
                        "betweenExample": "Status:[10 TO 20]",
                        "dateModifications": "Modifications basées sur la date:",
                        "dateModificationsTitle": "1. Afficher les données modifiées au cours des 3 derniers jours",
                        "dateModificationsTitleEx": "__modified: [\"now-3d/d\" TO \"now/d\"]",
                        "dateModificationsTitle1": "2. Afficher les lignes créées le 2025-02-04",
                        "dateModificationsTitleEx1": "__created: \"2025-02-04\"",
                        "equalTo": "Égal à (=)",
                        "equalToDescription": "Récupère les enregistrements où ItemNumber vaut 3000007.",
                        "equalToExample": "ItemNumber:3000007",
                        "example": "Exemple :",
                        "example1": "Exemple 1:",
                        "example2": "Exemple 2:",
                        "exists": "Existe",
                        "existsExample": "_ItemType:*",
                        "existsNotExists": "Existe / N'existe pas",
                        "existsNotExistsDescription": "Ici, il n'existe pas d'équivalent direct de EXISTS ou NOT EXISTS, mais vous pouvez utiliser des requêtes pour vérifier la présence ou l'absence d'un champ.",
                        "greaterThan": "Supérieur à (>)",
                        "greaterThanDescription": "Récupère les enregistrements où le statut est supérieur à 20.",
                        "greaterThanExample": "Status:>10",
                        "greaterThanOrEqualTo": "Supérieur ou égal à (>=)",
                        "greaterThanOrEqualToDescription": "Récupère les enregistrements où le statut est supérieur ou égal à 20.",
                        "greaterThanOrEqualToExample": "Status:>=10",
                        "in": "Dans",
                        "inDescription": "En SQL, IN permet de définir plusieurs valeurs. Ici, on utilise OR.",
                        "inExample": "ItemNumber:(3000007 OR 3000047)",
                        "introductionDescription": "Guide pour écrire des filtres avancés avec la syntaxe OpenSearch.",
                        "introductionTitle": "Introduction",
                        "lessThan": "Moins que (<)",
                        "lessThanDescription": "Récupère les enregistrements où le statut est inférieur à 20.",
                        "lessThanExample": "Status:<20",
                        "lessThanOrEqualTo": "Inférieur ou égal à (<=)",
                        "lessThanOrEqualToDescription": "Récupère les enregistrements où Status est inférieur ou égal à 20.",
                        "lessThanOrEqualToExample": "Status:<=20",
                        "like": "Comme",
                        "likeDescription": "En SQL, l'opérateur LIKE est utilisé pour faire correspondre des modèles. Ici, vous utilisez les caractères génériques * et ?.",
                        "likeExample": "ItemNumber:300*",
                        "linkedSearchWidgetTitle": "Exemple pour un widget de recherche lié",
                        "notEqualTo": "Différent de (!=)",
                        "notEqualToDescription": "Récupère les enregistrements où ItemNumber est différent de 3000007.",
                        "notEqualToExample1": "!ItemNumber:3000007",
                        "notEqualToExample2": "!ItemNumber:3000007",
                        "notExists": "N’existe pas",
                        "notExistsExample": "-_ItemType:*",
                        "operatorsTitle": "Opérateurs:",
                        "or": "OU",
                        "orDescription": "OR affiche un enregistrement si une des conditions est vraie.",
                        "orExample": "ItemType:Ext OR (Status:[15 TO 25])",
                        "tagValue": "Exemple pour valeur de tag",
                        "tagValueExample": "ItemType: {{ tags.[ItemType] }}",
                        "tagValueExample1": "ProductGroup: {{ tags.[Product Group] }}",
                        "where": "Où",
                        "whereDescription": "En SQL, WHERE filtre les enregistrements. Ici, on utilise Champ:Valeur.",
                        "whereExample": "ItemNumber:3000007"
                    },
                    "appearance": "Apparence",
                    "backgroundColor": "Couleur de fond",
                    "boldText": "Texte en gras",
                    "charts": {
                        "barChart": "Histogramme",
                        "cakeChart": "Camembert",
                        "lineChart": "Courbe"
                    },
                    "chooseDataset": "Choisir un jeu de données",
                    "chooseWorkflow": "Choisir un workflow",
                    "chooseEvent": "Choisir un événement",
                    "customBackgroundColor": "Couleur de fond personnalisée",
                    "data": "Données",
                    "dataFieldComparison": "Comparaison de champs",
                    "dataWarningRules": "Règles d’avertissement sur les données",
                    "defaultBackgroundColor": "Couleur de fond par défaut",
                    "details": "Détails",
                    "filter": "Filtre",
                    "filtersHeader": "Filtres",
                    "fonts": "Polices",
                    "fontSize": "Taille de police",
                    "fontSizeForTitle": "Taille de police pour le titre",
                    "foregroundColor": "Couleur du texte",
                    "from": "De",
                    "iconLeft": "Icône gauche",
                    "iconLeftSize": "Taille icône gauche",
                    "iconPosition": "Position de l’icône",
                    "iconRight": "Icône droite",
                    "iconRightSize": "Taille icône droite",
                    "iconSize": "Taille de l’icône",
                    "linked": "lié",
                    "linkedWidgets": "Widgets liés",
                    "linkedWidgetsDescription": "Sélectionner les widgets à lier aux données d’entrée",
                    "linkFrom": "Lié depuis",
                    "linkFromFieldCaption": "Sélectionner le widget source utilisé comme déclencheur",
                    "mandatoryDatasetForWidget": "Jeu de données obligatoire pour le widget",
                    "eventForWidget": "Événement émis par Lié depuis",
                    "mandatoryField": "Champ obligatoire",
                    "name": "Nom",
                    "operators": {
                        "average": "Moy",
                        "max": "Max",
                        "min": "Min",
                        "sum": "Somme"
                    },
                    "optionalDescriptionOfTheDashboard": "Description optionnelle du tableau de bord",
                    "searchTableColumnsPlaceholder": "Rechercher des colonnes",
                    "tableColumn": "Colonnes du tableau",
                    "select": "Sélectionner",
                    "selectAll": "Tout sélectionner",
                    "dragDropTableColumns": "Glissez-déposez pour ordonner les colonnes. Au moins une colonne est requise.",
                    "selectDivider": "Sélectionner un séparateur",
                    "selectIcon": "Sélectionner une icône",
                    "selectIconSize": "Sélectionner la taille de l’icône",
                    "selectLeftIcon": "Sélectionner l’icône gauche",
                    "selectLinkedWidgets": "Sélectionner les widgets liés",
                    "selectRightIcon": "Sélectionner l’icône droite",
                    "selectWidget": "Sélectionner un widget",
                    "showFilters": "Afficher les filtres",
                    "showViewDetailsButton": "Afficher Voir les détails",
                    "simpleFilter": "Filtre simple",
                    "sqlBasedCodeQuery": "Requête",
                    "closeSqlHelper": "Fermer l’aide requête",
                    "showSqlHelper": "Afficher l’aide requête",
                    "tagFieldComparison": "Comparaison par tag",
                    "text": "Texte",
                    "to": "À",
                    "widgetData": "Données du widget",
                    "widgetDataset": "Jeu de données du widget",
                    "widgetDescription": "Description du widget",
                    "widgetName": "Nom du widget",
                    "workflows": "Workflows",
                    "connectedWorkflow": "Workflow connecté",
                    "workflowsInputSettings": "Paramètres d’entrée workflow",
                    "triggerExpression": "Expression de déclenchement",
                    "triggerExpressionInfo": "Expression JSONata déterminant l’entrée du workflow. Peut inclure ",
                    "triggerExpressionInfo1": " pour les données liées\n",
                    "dataExpression": "Expression de données",
                    "dataExpressionInfo": "Expression pour extraire les données de la réponse workflow",
                    "descriptionExpression": "Expression de description",
                    "descriptionExpressionInfo": "Expression pour extraire un texte descriptif",
                    "workflowResultSettings": "Paramètres résultat workflow",
                    "workflowResultSettingsInfo": "Tous les paramètres ci-dessous sont ",
                    "workflowResultSettingsInfo1": " et acceptent JSONpath ou JSONata",
                    "optional": "OPTIONNEL",
                    "detailsDataExpression": "Expression de données pour les détails",
                    "detailsDataExpressionInfo": "Expression pour extraire les données lors du clic sur ",
                    "detailsDataExpressionInfo1": " dans certains widgets",
                    "viewDetails": "Voir les détails",
                    "detailsTextExpression": "Expression texte détails",
                    "detailsTextExpressionInfo": "Expression pour le texte affiché à la place de ",
                    "detailsTextExpressionInfo1": " dans certains widgets",
                    "detailsUrlExpression": "Expression URL détails",
                    "detailsUrlExpressionInfo": "Expression pour extraire l’URL utilisée au clic sur ",
                    "detailsUrlExpressionInfo1": " dans certains widgets",
                    "enableSelection": "Activer la sélection",
                    "multipleRows": "Lignes multiples",
                    "singleRow": "Ligne unique",
                    "editableTable": "Tableau éditable",
                    "selectEditableFields": "Sélectionner les champs modifiables",
                    "typeEditableFields": "Saisir et appuyer sur Entrée pour ajouter",
                    "useDropdown": "Utiliser une liste déroulante",
                    "selectDropdownColumn": "Sélectionner la colonne déroulante",
                    "selectColumn": "Sélectionner une colonne",
                    "dropdownColumnName": "Nom de la colonne déroulante",
                    "enterColumnName": "Saisir le nom de la colonne",
                    "addDropdownValue": "Ajouter une valeur déroulante",
                    "typeDropdownValues": "Saisir et appuyer sur Entrée pour ajouter des valeurs",
                    "actions": "Actions",
                    "manageActions": "Gérer les actions",
                    "actionSettings": "Paramètres d’action",
                    "listOfActions": "Liste des actions",
                    "addNewAction": "Ajouter une action",
                    "noActionsYet": "Aucune action pour l’instant",
                    "actionName": "Nom de l’action",
                    "actionDescription": "Description de l’action",
                    "selectWorkflow": "Sélectionner un workflow",
                    "advancedWorkflowSettings": "Paramètres avancés workflow",
                    "triggerAction": "Déclencher l’action",
                    "triggerActionInfo": "Expression JSONata définissant l’entrée. Peut inclure $selected ou $linked",
                    "removeRowFromTable": "Supprimer la ligne du tableau",
                    "removeOnSuccess": "Supprimer en cas de succès",
                    "removeOnFailure": "Supprimer en cas d’échec",
                    "verifyBeforeAction": "Vérifier avant action",
                    "chooseChart": "Choisir un type de graphique",
                    "eventHandling": "Gestion des événements",
                    "showOnEvent": "Afficher lors de l’événement",
                    "hideOnEvent": "Cacher lors de l’événement",
                    "showOnEventDescription": "Garde le widget caché jusqu’à ce que cet événement survienne",
                    "hideOnEventDescription": "Cache le widget lorsque cet événement survient",
                    "transform": "Transformer",
                    "transformDescription": "Transformer les données d’entrée avec JSONata. $linked est le chemin vers les données liées.",
                    "event": "Événement",
                    "loadWidgetData": "Charger les données du widget au chargement du tableau de bord",
                    "shouldNotLoad": "Ne doit pas charger initialement les données pour ce widget",
                    "legacyDatasource": "Si vous modifiez la source de données dans la nouvelle version, ce changement sera irréversible. Le workflow appliqué ne fonctionnera alors que dans la nouvelle version et ne sera plus compatible avec l'ancienne version"
                },
                "iconSize": {
                    "extraSmall": "Très petit",
                    "small": "Petit",
                    "medium": "Moyen",
                    "large": "Grand"
                },
                "updatedSuccessfully": "Widget mis à jour avec succès",
                "viewDetails": "Voir détails",
                "widgetDataset": "Jeu de données du widget",
                "widgetCustomTable": "Table personnalisée du widget",
                "widgetDatasource": "Source de données du widget",
                "widgetChartType": "Type de graphique",
                "widgetWorkflow": "Workflow du widget",
                "widgetDescription": "Description du widget",
                "widgetName": "Nom du widget",
                "xAxis": "Axe X",
                "yAxis": "Axe Y",
                "last": "Dernier",
                "first": "Premier",
                "dataSource": {
                    "CUSTOM_TABLE": "Table personnalisée",
                    "EVENT": "Événement",
                    "WORKFLOW": "Workflow"
                },
                "selectCustomTable": "Sélectionner une table personnalisée",
                "selectWorkflow": "Sélectionner un workflow",
                "selectEvent": "Sélectionner un événement",
                "charts": {
                    "WIDGET_LINE_CHART": "Graphique en ligne",
                    "WIDGET_BAR_CHART": "Histogramme",
                    "WIDGET_PIE_CHART": "Diagramme circulaire"
                },
                "linkedTo": "Lié à",
                "itemSelected": "{item} élément sélectionné",
                "itemsSelected": "{item} éléments sélectionnés",
                "selectAction": "Sélectionner une action",
                "confirmExecute": "Êtes-vous sûr de vouloir exécuter « {actionName} » ?",
                "actionSuccessMsg": "{actionName} exécutée avec succès sur les éléments sélectionnés.",
                "actionFailMsg": "{actionName} a échoué. Consultez le journal du workflow.",
                "exportItem": "Exporter {count} élément",
                "exportItems": "Exporter {count} éléments",
                "exportTooltipSingle": "Télécharger {count} ligne en Excel",
                "exportTooltipMultiple": "Télécharger {count} lignes en Excel",
                "showAllItems": "Afficher tous les éléments",
                "failedToLoadTableData": "Échec du chargement des données du tableau",
                "failedToLoadDataForWidget": "Échec du chargement des données pour {widgetType} - {widgetName}",
                "failedToLoadInfoboxData": "Échec du chargement des données de l’infobox",
                "noRecordsFound": "Aucun enregistrement trouvé",
                "notPossibleToDwonload": "Impossible de télécharger le fichier.",
                "filterCompatibility": "Si vous modifiez ces filtres dans la nouvelle version, le changement sera irréversible.\nLes filtres ne fonctionneront plus dans l’ancienne version.",
                "noColumnsSelected": "Aucune colonne sélectionnée. Sélectionnez au moins une colonne.",
                "permissionError": "Impossible de récupérer les données. Les autorisations requises sont manquantes",
                "tagPermissionError": "Impossible de récupérer les données. Un tag requis est manquant dans la comparaison de tags",
                "notPossibleToLoadData": "Impossible de charger les données"
            }
        },
        "dashboardName": "Nom du tableau de bord",
        "dashboardWidgets": "Widgets du tableau de bord",
        "dataset": "Choisir un jeu de données pour le widget",
        "deleteConfirmation": "Confirmation de suppression",
        "deleteDashboardSuccess": "Tableau de bord supprimé avec succès",
        "deleteWidgetSuccess": "Widget supprimé avec succès",
        "dragAndDropPreview": "Glisser-déposer le widget dans l’aperçu",
        "editDashboard": "Modifier le tableau de bord",
        "exitEditMode": "Quitter le mode édition",
        "loadMore": "Charger plus de tableaux de bord",
        "mandatoryField": "Champ obligatoire",
        "newDashboard": "Nouveau tableau de bord",
        "noDashboardsOnSearch": "Aucun tableau de bord ne correspond à la recherche",
        "noRecords": "Aucun enregistrement à afficher",
        "selectDashboard": "Sélectionner un tableau de bord",
        "specialCharError": "Les caractères spéciaux : / $ *? {'{ }'} [] & % ne sont pas autorisés",
        "title": "Tableaux de bord",
        "widgetDataset": "Jeu de données du widget",
        "widgetDescription": "Description du widget",
        "widgetPlaceholder": "Espace réservé du widget",
        "widgetName": "Nom du widget",
        "widgetNameCannotBeEmpty": "Le nom du widget ne peut pas être vide.",
        "widgetPreview": "Aperçu du widget"
    },
    "menuItems": {
        "dashboard": "Tableaux de bord"
    },
    "widget": {
        "addWidget": "Ajouter un widget",
        "filters": {
            "convertedFilters": "Éléments filtrés convertis",
            "convertedAdvanced": "Filtre avancé converti",
            "editGroupName": {
                "title": "Modifier le nom du groupe de filtres",
                "label": "Nouveau nom"
            },
            "header": "Filtre",
            "and": "et",
            "rule": "Règle",
            "connectedWith": "(connecté avec {operator})",
            "newFilterName": "Nouveau filtre",
            "newFilterDescription": "",
            "newGroup": "Nouveau groupe",
            "addConditionsList": "Ajouter une liste de conditions",
            "addQuery": "Ajouter une requête manuelle",
            "addFilterItem": "Ajouter un filtre",
            "filterSummary": "RÉSUMÉ DU FILTRE",
            "selectFields": "Champ",
            "selectCondition": "Condition",
            "valueType": "Type de valeur",
            "provided": "Valeur",
            "tag": "Tag",
            "field": "Champ",
            "noConditions": "Aucune condition supportée pour ce type de champ",
            "startDate": "Date de début",
            "endDate": "Date de fin",
            "date": "Date",
            "range": "Plage",
            "logical": {
                "and": "ET",
                "or": "OU"
            },
            "conditions": {
                "string": {
                    "EQUALS": "Égal à",
                    "GREATER_THAN": "Après",
                    "GREATER_THAN_OR_EQUALS": "Le ou après",
                    "NOT_EQUALS": "Différent de",
                    "CONTAINS": "Contient",
                    "DOES_NOT_CONTAIN": "Ne contient pas",
                    "IS_BLANK": "Est vide",
                    "IS_NOT_BLANK": "N’est pas vide",
                    "LESS_THAN": "Avant",
                    "LESS_THAN_OR_EQUALS": "Le ou avant"
                },
                "array": {
                    "CONTAINS": "Contient",
                    "DOES_NOT_CONTAIN": "Ne contient pas"
                },
                "number": {
                    "EQUALS": "Égal à",
                    "NOT_EQUALS": "Différent de",
                    "LESS_THAN": "Moins que",
                    "LESS_THAN_OR_EQUALS": "Moins ou égal à",
                    "GREATER_THAN": "Plus grand que",
                    "GREATER_THAN_OR_EQUALS": "Plus grand ou égal à"
                },
                "date": {
                    "EQUALS": "Est le",
                    "NOT_EQUALS": "N’est pas le",
                    "CONTAINS": "Contient",
                    "DOES_NOT_CONTAIN": "Ne contient pas",
                    "IS_BLANK": "Est vide",
                    "IS_NOT_BLANK": "N’est pas vide",
                    "LESS_THAN": "Avant",
                    "GREATER_THAN": "Après",
                    "LESS_THAN_OR_EQUALS": "Le ou avant",
                    "GREATER_THAN_OR_EQUALS": "Le ou après"
                },
                "boolean": {
                    "EQUALS": "Est vrai",
                    "NOT_EQUALS": "Est faux",
                    "CONTAINS": "Est vrai",
                    "NOT_CONTAINS": "Est faux"
                }
            },
            "valueTypes": {
                "PROVIDED": "Manuel",
                "TAG": "Tags",
                "FIELD": "Comparer",
                "CONTEXT": "Contexte",
                "RELATIVE_DATE": "Date relative"
            }
        },
        "filterTab": {
            "addFilter": "Ajouter une règle de filtre",
            "editFilter": "Modifier le filtre",
            "deleteFilter": "Supprimer le filtre",
            "appliedFilter": "Filtrage activé",
            "legacyFilterInfo": "Filtre de Vince Live v.1 appliqué",
            "deleteFilterConfirmation": "Êtes-vous sûr de vouloir supprimer le filtre?",
            "filterDeleted": "Filtre supprimé avec succès.",
            "noFilters": "Aucun filtre appliqué à ce widget"
        },
        "connectedTo": "Connecté à "
    },
    "widgetType": {
        "WIDGET_DISPLAY_BOX": {
            "label": "Widget d’affichage"
        },
        "WIDGET_INFO_BOX": {
            "label": "Widget d’info"
        },
        "WIDGET_LINE_CHART": {
            "label": "Widget graphique"
        },
        "WIDGET_SEARCH_BOX": {
            "label": "Widget d’entrée"
        },
        "WIDGET_TABLE": {
            "label": "Widget tableau"
        },
        "WIDGET_MAP": {
            "label": "Widget carte"
        },
        "WIDGET_WORKFLOW": {
            "label": "Widget workflow"
        }
    }
}
